import React from 'react'
import { compose } from 'redux'
import { lpForm } from 'lp-form'
import { Field, propTypes as formPropTypes } from 'redux-form'
import { ButtonArea, SubmitButton, Input, Checkbox } from 'lp-components'
import { Link } from 'react-router'

const propTypes = {
  ...formPropTypes,
}

function SignInForm({ error, handleSubmit, submitting }) {
  return (
    <form onSubmit={handleSubmit} noValidate>
      {error && (
        <p className="full-error-message" role="alert">
          {error}
        </p>
      )}
      <Field
        name="email"
        type="email"
        component={Input}
        label="Email"
        autoComplete="email"
      />
      <Field
        name="password"
        type="password"
        component={Input}
        label="Password"
        autoComplete="current-password"
      />
      <Field
        name="persistSession"
        label="Keep me signed in"
        component={Checkbox}
      />
      <ButtonArea>
        <SubmitButton submitting={submitting} data-cy="sign-in-with-email">
          Sign In
        </SubmitButton>
        <Link
          to={'sign-in/forgot-password'}
          className="link-secondary"
          data-cy="forgot-password-trigger"
        >
          Forgot Password?
        </Link>
      </ButtonArea>
    </form>
  )
}

SignInForm.propTypes = propTypes

export default compose(
  lpForm({
    name: 'school-portal-sign-in',
    constraints: {
      email: {
        presence: { message: '^Enter your email address.' },
        email: {
          message: '^Use an email address like name@example.com.',
        },
      },
      password: {
        presence: { message: '^Enter your password.' },
        length: {
          minimum: 5,
          tooShort: '^Enter at least %{count} characters.',
        },
      },
    },
    initialValues: {
      persistSession: true,
    },
  })
)(SignInForm)
